export const aboutValues = [
  {
    title: "Evidence-Based",
    description:
      "Every programme and recommendation is grounded in verified data, factory audits, and measurable outcomes rather than assumptions.",
    icon: "ri-bar-chart-box-line",
  },
  {
    title: "Systematic",
    description:
      "Innovation is not accidental. TIE builds structured pathways - from ideation to implementation to scale - that factories can replicate.",
    icon: "ri-flow-chart",
  },
  {
    title: "Collaborative",
    description:
      "No single entity owns innovation. TIE exists to bridge factories, brands, researchers, and solution providers under one operating system.",
    icon: "ri-team-line",
  },
  {
    title: "Sustainable",
    description:
      "Short-term pilots are not enough. TIE designs programmes that embed innovation capacity into factory culture and governance.",
    icon: "ri-recycle-line",
  },
  {
    title: "Transparent",
    description:
      "Progress, recognition, and gaps are documented openly. TIE publishes results so the entire ecosystem learns and improves together.",
    icon: "ri-shield-check-line",
  },
  {
    title: "Bangladesh-Rooted",
    description:
      "TIE is built by Bangladesh's textile professionals for Bangladesh's factories, with global standards and local relevance at its core.",
    icon: "ri-map-pin-2-line",
  },
];

export const whatWeDo = [
  {
    title: "Connect",
    description:
      "We map and match factories with the right experts, solution providers, researchers, and institutional partners for their specific innovation goals.",
    icon: "ri-links-line",
  },
  {
    title: "Implement",
    description:
      "Through PIIC and tailored programmes, we help factories install new processes, technologies, and management systems on the production floor.",
    icon: "ri-settings-3-line",
  },
  {
    title: "Measure",
    description:
      "Every intervention is tracked with before-and-after metrics - efficiency, quality, sustainability, and worker welfare indicators.",
    icon: "ri-line-chart-line",
  },
  {
    title: "Scale",
    description:
      "Successful pilots are converted into repeatable playbooks so innovation spreads across factories, groups, and supply chains.",
    icon: "ri-stack-line",
  },
  {
    title: "Recognize",
    description:
      "We certify and celebrate factories that demonstrate measurable innovation maturity, creating market differentiation and buyer confidence.",
    icon: "ri-award-line",
  },
  {
    title: "Research",
    description:
      "We commission and publish sector-level research that identifies gaps, benchmarks performance, and guides policy and investment.",
    icon: "ri-microscope-line",
  },
];

export const aboutStats = [
  { value: "250+", label: "Innovation Projects Deployed" },
  { value: "80+", label: "Partner Factories" },
  { value: "30+", label: "Expert Associates" },
  { value: "12", label: "Research Publications" },
];